export const iconFontAwesomeSocialUserPlus = (
	<i className="fa-solid fa-user-plus"></i>
);
